export interface FinanceCost {
    id: number;
    appraisal_basic_id: number;
    finance_amount: number;
    interest_rate: number;
    loan_month: number;
    interest: number;
    arrangement_fees: number;
    exist_fees: number;
    lawyer_fees: number;
}

// to single object maping
export const mapFinanceCost = (data:any): FinanceCost => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: FinanceCost ={
        id: data.id,
        appraisal_basic_id: data.appraisal_basic_id,
        finance_amount: data.finance_amount,
        interest_rate: data.interest_rate,
        loan_month: data.loan_month,
        interest: data.interest,
        arrangement_fees: data.arrangement_fees,
        exist_fees: data.exist_fees,
        lawyer_fees: data.lawyer_fees,
    }
    return res;
}

// maping list objects
export const mapFinanceCosts = (data:any[]): FinanceCost[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapFinanceCost);
}